import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { normalizeExternalUrl, toInternalPath } from "@/lib/utils/url";
import { Button, IconV2, Tag, Typography } from "@bookips/sds";
import Image from "next/image";
import { useRouter } from "next/router";
import { PassCategoryWithString } from "../../../api/membership";
import PassProgressBar from "./PassProgressBar";
import { PASS_CATEGORY_TAG_COLOR, PASS_CATEGORY_THUMBNAIL } from "./constants";
// 마이쏠북 이용권 관리 — 사용중 탭 카드
// 시안 참조: Figma 2222:18445 Membership Module (4케이스)
const MyPassCard = (param)=>{
    let { pass , onOpenInfo  } = param;
    var _productInfo_useButtonUrl;
    const router = useRouter();
    const { productInfo , startedAt , expiredAt , remainDay  } = pass;
    var _pass_isPending;
    // BE 점진 배포 중 isPending 누락 시 false 로 폴백 (active 처리).
    const isPending = (_pass_isPending = pass.isPending) !== null && _pass_isPending !== void 0 ? _pass_isPending : false;
    const category = productInfo.category;
    const { title  } = productInfo;
    // 빈 문자열·공백 케이스에서도 CTA 가 노출되지 않도록 trim 후 truthy 체크.
    const useButtonHref = (_productInfo_useButtonUrl = productInfo.useButtonUrl) === null || _productInfo_useButtonUrl === void 0 ? void 0 : _productInfo_useButtonUrl.trim();
    // 내부 도메인이면 path만 추출해 SPA 이동, 외부 URL이면 같은 탭으로 이동 (BE 실수 폴백).
    const internalPath = useButtonHref ? toInternalPath(useButtonHref) : null;
    const categoryLabel = PassCategoryWithString[category];
    const thumbnailSrc = PASS_CATEGORY_THUMBNAIL[category];
    // MX-583 / MX-584 — 이용권 카드 액션 공통 Property
    const cardActionProps = {
        Position: "이용권 관리",
        "Membership Id": pass.membershipId,
        "Product Id": productInfo.id,
        Title: productInfo.title,
        Category: productInfo.category,
        "Remaining Days": remainDay
    };
    // MX-583 — 상세정보 버튼 클릭 시
    const handleOpenInfo = ()=>{
        mixpanelEvent("Membership Info Button Clicked", {
            ...cardActionProps,
            "Button Name": "상세정보"
        });
        onOpenInfo === null || onOpenInfo === void 0 ? void 0 : onOpenInfo(pass);
    };
    // MX-584 — 이용권 사용하기 버튼 클릭 시
    const handleUseTicket = ()=>{
        mixpanelEvent("Membership Info Button Clicked", {
            ...cardActionProps,
            "Button Name": "이용권 사용하기",
            "Button URL": useButtonHref
        });
        if (internalPath) {
            router.push(internalPath);
        } else if (useButtonHref) {
            // protocol-less URL 이 상대 경로로 잘못 해석되지 않도록 정규화 후 이동.
            window.location.href = normalizeExternalUrl(useButtonHref);
        }
    };
    // MX-598 — 사용 대기 툴팁 노출 시
    const handlePendingTooltipOpenChange = (open)=>{
        if (open) {
            mixpanelEvent("Tooltip Viewed", {
                Position: "이용권 관리",
                "Tooltip Type": "이용권 상태값 설명(사용대기)",
                "Tooltip Text": "현재 사용중인 이용권의 만료 후 시작될 예정이에요."
            });
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "rounded-md border-b border-gray-50",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex w-full flex-col gap-5 p-5",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "flex items-center gap-2",
                    children: /*#__PURE__*/ _jsx(Tag, {
                        color: PASS_CATEGORY_TAG_COLOR[category],
                        size: "sm",
                        bold: true,
                        children: categoryLabel
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex gap-4",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "size-14 shrink-0 overflow-hidden rounded-lg border border-gray-300/20",
                            children: /*#__PURE__*/ _jsx(Image, {
                                src: thumbnailSrc,
                                alt: title,
                                width: 56,
                                height: 56,
                                className: "size-full object-cover"
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex flex-1 items-start",
                            children: /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle1",
                                className: "text-primary line-clamp-2",
                                children: title
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(PassProgressBar, {
                    startDate: startedAt,
                    endDate: expiredAt,
                    remainDay: remainDay,
                    isPending: isPending,
                    pendingDescription: /*#__PURE__*/ _jsxs(Typography, {
                        variant: "subtitle1",
                        className: "text-white",
                        children: [
                            "현재 사용중인 이용권의 ",
                            /*#__PURE__*/ _jsx("br", {}),
                            " 만료 후 시작될 예정이에요."
                        ]
                    }),
                    onPendingTooltipOpenChange: handlePendingTooltipOpenChange
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex gap-1.5",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "stroke",
                            color: "secondary",
                            size: "md",
                            onClick: handleOpenInfo,
                            children: "상세정보"
                        }),
                        useButtonHref && /*#__PURE__*/ _jsx(Button, {
                            variant: "stroke",
                            color: "secondary",
                            size: "md",
                            className: "w-full flex-1",
                            disabled: isPending,
                            rightElement: /*#__PURE__*/ _jsx(IconV2.ArrowRight, {
                                size: "xs"
                            }),
                            onClick: handleUseTicket,
                            children: "이용권 사용하기"
                        })
                    ]
                })
            ]
        })
    });
};
export default MyPassCard;
